import { trackAction } from './ab_track'

function handlePopularArticleClick(event) {
  if (!(event.target instanceof Element)) return

  const link = event.target.closest('[data-popular-article-ranking] a')
  if (!link) return

  const ranking = link.closest('[data-popular-article-ranking]')
  const card = link.closest('[data-article-id]')
  if (!(ranking instanceof HTMLElement) || !(card instanceof HTMLElement)) return

  const snapshotId = ranking.dataset.snapshotId || ''
  const postId = Number.parseInt(card.dataset.articleId || '', 10)
  const cards = Array.from(ranking.querySelectorAll('[data-article-id]'))
  const rank = cards.indexOf(card) + 1
  if (!/^[a-f0-9]{64}$/.test(snapshotId)
    || !Number.isInteger(postId)
    || postId < 1
    || rank < 1
    || rank > 4) return

  trackAction('popular_article_clicked', {
    surface: 'reform_top',
    rank,
    post_id: postId,
    snapshot_id: snapshotId,
  })
}

export function bindPopularArticleClickTracking() {
  document.addEventListener('click', handlePopularArticleClick)
}
